// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"451897ac","455":"60fa4b3a","901":"f6aafbad","977":"6a7f6471"}[chunkId] + ".chunk.js";
};